var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.378,
    height: 19.378,
    viewBox: "0 0 19.378 19.378",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffaaac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed2024"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19581",
    "data-name": "Group 19581",
    transform: "translate(0 -29.066)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2632",
    "data-name": "Rectangle 2632",
    width: 19.378,
    height: 19.378,
    rx: 6,
    transform: "translate(0 29.066)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "UI_icon_show_filled",
    "data-name": "UI icon/show/filled",
    transform: "translate(3 33.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M6.712,10A6.662,6.662,0,0,1,2.421,8.436,9.7,9.7,0,0,1,.217,5.81a1.618,1.618,0,0,1,0-1.619,9.7,9.7,0,0,1,2.2-2.626,6.667,6.667,0,0,1,8.582,0,9.709,9.709,0,0,1,2.2,2.626,1.618,1.618,0,0,1,0,1.619A9.706,9.706,0,0,1,11,8.436,6.663,6.663,0,0,1,6.712,10Zm0-7.144A2.111,2.111,0,0,0,4.639,5,2.111,2.111,0,0,0,6.712,7.143,2.111,2.111,0,0,0,8.786,5,2.112,2.112,0,0,0,6.712,2.857Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewsIcon);
export default __webpack_public_path__ + "static/media/viewsIcon.d5c2e2b13c97da682cf4f7ca73dbd2a9.svg";
export { ForwardRef as ReactComponent };